import { useAuth } from "@/contexts/Auth";
import { useGlobalData } from "@/contexts/GlobalData";
import getMissionsService from "@/services/getMissionsService";

function useUpdateMission() {
    const { token } = useAuth();
    const { setMissionsData } = useGlobalData();
    const updateMissionData = async () => {
        const newMissionData = await getMissionsService(token);
        console.log("🚀 ~ updateMissionData ~ newMissionData:", newMissionData);
        setMissionsData(newMissionData);
    };
    return {
        updateMissionData,
    };
}

export default useUpdateMission;
